import React, { useState } from 'react';
import './ShareWithBossModal.css';

const ShareWithBossModal = ({ onClose }) => {
  const [bossEmail, setBossEmail] = useState('');
  const [bossName, setBossName] = useState('');
  const [yourName, setYourName] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!bossEmail || !bossName || !yourName) return;

    setIsSending(true);

    // Simulate sending email
    await new Promise(resolve => setTimeout(resolve, 1500));

    setIsSending(false);
    setIsSent(true);
  };

  const emailPreview = `Hi ${bossName || '[Boss Name]'},

I just tried Templafy's AI-powered document creation tool and it was impressive. In about 2 minutes, it generated a professional, on-brand presentation.

Here's what stood out:
• AI drafts complete documents instantly
• Everything stays compliant with brand guidelines
• Works directly inside Office apps
• Could save our team 4+ hours per week

I think this could really help streamline how we create documents. Would you be open to a quick demo?

Best,
${yourName || '[Your Name]'}`;

  if (isSent) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-container success-modal" onClick={e => e.stopPropagation()}>
          <button className="modal-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>

          <div className="success-content">
            <div className="success-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <circle cx="24" cy="24" r="22" stroke="#10B981" strokeWidth="2"/>
                <path d="M15 24L21 30L33 18" stroke="#10B981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 className="success-title">Email sent!</h2>
            <p className="success-message">
              We've sent your message to {bossName}. Fingers crossed for a demo soon!
            </p>
            <button className="success-button" onClick={onClose}>
              Done
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>

        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title">Tell your boss about Templafy</h2>
            <p className="modal-subtitle">
              We'll send them a pre-written email on your behalf. You can customize it below.
            </p>
          </div>

          <form className="modal-form" onSubmit={handleSend}>
            <div className="form-group">
              <label className="form-label">Boss's email</label>
              <input
                type="email"
                className="form-input"
                placeholder="boss@company.com"
                value={bossEmail}
                onChange={e => setBossEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Boss's name</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Their first name"
                  value={bossName}
                  onChange={e => setBossName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Your name</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Your first name"
                  value={yourName}
                  onChange={e => setYourName(e.target.value)}
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className={`send-button ${isSending ? 'sending' : ''}`}
              disabled={!bossEmail || !bossName || !yourName || isSending}
            >
              {isSending ? (
                <>
                  <div className="button-spinner" />
                  Sending...
                </>
              ) : (
                <>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M14.5 1.5L7 9M14.5 1.5L10 14.5L7 9M14.5 1.5L1.5 6L7 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Send Email
                </>
              )}
            </button>
          </form>

          <div className="or-divider">
            <span>OR</span>
          </div>

          <a
            href="https://www.templafy.com/demo"
            className="demo-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Request a Demo Yourself
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>

          {/* Email Preview */}
          <div className="email-preview">
            <div className="preview-header">
              <div className="preview-envelope">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M2 6L10 11L18 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <span className="preview-label">Email Preview</span>
            </div>
            <div className="preview-content">
              <pre className="preview-text">{emailPreview}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareWithBossModal;
